import { mapFromCollectionNameToSeasonName } from "@constants/mappers";

import {
  type PurchaseOption,
  UPGRADE_PURCHASE_OPTION,
} from "@lib/api/checkout.types";
import type { TechniqueSeason } from "@root/constants";

/**
 * The SKU a signed-in member without full access is sold (OMG-2717). omg-api
 * sells the upgrade SKU only to partial owners, so a member who owns nothing
 * gets the regular full bundle. A failed getMe also reads as "no
 * entitlements", so it keeps the upgrade SKU rather than guess. One source for
 * NmhContext's pricing prefetch and /upsell, so the two cannot drift.
 */
export const memberPurchaseOption = ({
  entitlements,
  isEntitlementsError,
}: {
  entitlements: readonly TechniqueSeason[];
  isEntitlementsError: boolean;
}): PurchaseOption => {
  const ownsNothing =
    !isEntitlementsError &&
    !Object.values(mapFromCollectionNameToSeasonName).some((season) =>
      entitlements.includes(season as TechniqueSeason),
    );
  return ownsNothing ? "series,series2,series3" : UPGRADE_PURCHASE_OPTION;
};
